import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
import { ScrollSmoother } from "gsap/all";
import { SplitText } from "gsap/all";
import { ScrambleTextPlugin } from "gsap/all";

// let smoke = document.getElementById("smoke");

// function createSmoke(e) {
//   let elem = document.createElement("div");
//   elem.classList.add(`elem`);

//   elem.style.left = `${e.clientX}px`;
//   elem.style.top = `${e.clientY}px`;
//   smoke.appendChild(elem);

//   elem.addEventListener("animationend", () => {
//     elem.remove();
//   });
// }

// document.addEventListener("mousemove", createSmoke);

// Nav Btn
const NavBtn = document.querySelector(".header-container__onbox-navbtn__btn");
const NavBarPage = document.querySelector(".header-container__navbarpage");
const NavClose = document.querySelector(
  ".header-container__navbarpage-close-btn-box-close"
);

NavBtn.addEventListener("click", function (e) {
  NavBarPage.classList.add("navopen");
});

NavClose.addEventListener("click", function (e) {
  NavBarPage.classList.remove("navopen");
});

// Nav Page Links
const linkBoxes = document.querySelectorAll(
  ".header-contianer__navbarpage-navbox__link"
);
const linkText = document.querySelectorAll(
  ".header-container__navbarpage-navbox-text"
);

const options = {
  root: null,
  threshold: 0.1,
};

function callBack(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      linkText.forEach((text) => {
        text.classList.add("show");
      });
    } else {
      linkText.forEach((text) => {
        text.classList.remove("show");
      });
    }
  });
}

const observer = new IntersectionObserver(callBack, options);

linkBoxes.forEach((box) => {
  observer.observe(box);
});

/** SECTION-TWO */

function Observerfun(options, callBack, Element) {
  // Add Error Handling
  if (!Element) {
    console.log("Element to observe is null or undefined");
    return null;
  }

  try {
    const observer = new IntersectionObserver(callBack, options);
    Element.forEach((ele) => {
      observer.observe(ele);
      return observer;
    });
  } catch (error) {
    console.log("Error creating IntersectionObserver:", error);
    return null;
  }
}

const workBox = document.querySelectorAll(".section-two__work");
const Polygon = document.querySelector(".polygon");

// Add null checks before proceeding
if (!workBox || !Polygon) {
  console.log("Required elements not found:", {
    workBox: !!workBox,
    Polygon: !!Polygon,
  });
} else {
  const SectionTwoOptions = {
    root: null,
    threshold: Array.from({ length: 21 }, (_, i) => i * 0.05),
  };

  function SectionTwoCallBack(entries) {
    entries.forEach((entry) => {
      const ratio = entry.intersectionRatio;
      const poly = entry.target.children;
      if (poly.length > 1 && poly[1]) {
        const textBox = poly[1];
        const textChild = textBox.children;
        // Dynamic timing based on number of sentences
        const totalSentences = textChild.length;
        // Fixed total animation duration regardless of sentence count
        const totalAnimationTime = 0.8; // 80% of intersection ratio
        const delayBetween = totalAnimationTime / (totalSentences + 1);
        Array.from(textChild).forEach((child, index) => {
          /**v3 */
          // Each sentence gets equal portion of the scroll progress
          const start = index * delayBetween;
          const duration = delayBetween * 2; // Each sentence animates for 2 delay periods

          let progress = 0;
          if (ratio > start) {
            progress = Math.min(1, (ratio - start) / duration);
          }

          const translateY = (1 - progress) * 100;
          const opacity = progress;

          child.style.transform = `translateY(${translateY}px)`;
          // child.style.opacity = opacity;
          child.style.transition = `transform 0.5s cubic-bezier(0.19, 1, 0.22, 1), opacity 0.8s cubic-bezier(0.19, 1, 0.22, 1)`;
        });
      } else {
        console.warn(
          "poly[1] does not exist. Available children:",
          poly.length
        );
      }
      /* clip-path: polygon(20% 0%, 80% 0%, 90% 60%, 10% 60%); */
      poly[0].style.clipPath = `polygon(${20 - ratio * 30}% ${
        5 - ratio * 8
      }%, ${60 + ratio * 50}% ${20 - ratio * 25}%, ${70 + ratio * 40}% ${
        60 + ratio * 40
      }%, ${10 - ratio * 13}% ${60 + ratio * 40}%)`;
      poly[0].style.transition = `clip-path 0.5s ease`;
    });
  }
  // clip-path: polygon(20% 5%, 60% 20%, 70% 60%, 10% 60%);
  Observerfun(SectionTwoOptions, SectionTwoCallBack, workBox);
}

/**SECTION-THREE CURSOR BOX */
const SectionThree = document.querySelector(".section-three");
const SectionCursor = document.querySelector(
  ".section-three__cursorBox-cursor"
);

SectionThree.addEventListener("mouseenter", function (event) {
  SectionCursor.style.display = `flex`;
  SectionCursor.style.position = "fixed";
  SectionCursor.style.transition = `display 1s ease`;
  console.log(event, "mouseenter");
});

SectionThree.addEventListener("mousemove", function (event) {
  const x = event.clientX;
  const y = event.clientY;
  SectionCursor.style.transform = `translate(${x}px, ${y}px)`;
  SectionCursor.style.transition = `transform 0.2s ease`;
  // SectionCursor.style.top = `${y}px`;
  // SectionCursor.style.left = `${x}px`;
  console.log("mouseIn");
});

SectionThree.addEventListener("mouseout", function (event) {
  // Check if the mouse is leaving the section-three element itself
  // and not just moving to a child element
  if (!SectionThree.contains(event.relatedTarget)) {
    console.log("Actually leaving section-three");
    SectionCursor.style.display = "none";
    SectionCursor.style.position = "absolute";
  }
});

// Smooth scroll for the entire page
window.addEventListener(
  "scroll",
  function () {
    // This enables smooth scrolling for wheel/touchpad
  },
  { passive: true }
);

/** GSAP */

const ScreambleDuration = 3;
const ScrambleDelay = 1.4;
document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(
    ScrollTrigger,
    ScrollSmoother,
    SplitText,
    ScrambleTextPlugin
  );
  let smoother = ScrollSmoother.create({
    wrapper: "#smooth-wrapper",
    content: "#smooth-content",
    smooth: 2,
    smoothTouch: 0.1,
  });

  gsap.to(".section-three__reveal-box", {
    scale: 0.5,
    delay: 5,
    duration: 0.5,
    scrollTrigger: {
      trigger: ".section-three",
      start: "top 0%",
      end: "100% 100%",
      scrub: 0.5,
      pin: ".section-three__reveal-box",
      toggleActions: "restart none none none",
      // markers: true,
    },
  });

  gsap.to(".section-three__textbox", {
    // your animation
    scrollTrigger: {
      trigger: ".section-three",
      start: "top 0%",
      end: "100% 100%",
      scrub: 0.5,
      pin: ".section-three__textbox",
    },
  });

  // ARCHIVE
  gsap.to(".archive__container", {
    scale: 0.9,
    duration: 0.5,
    scrollTrigger: {
      trigger: ".archive__container",
      start: "top 0%",
      end: "bottom 0%",
      pin: true,
      scrub: true,
      pinSpacing: false,
      // markers: true,
    },
  });

  const splitElement = document.querySelectorAll(".split");

  splitElement.forEach((element, index) => {
    // SPLIT TEXT
    let mySplitText = new SplitText(element, { type: "chars" });
    let chars = mySplitText.chars;

    gsap.from(chars, {
      yPercent: 130,
      stagger: 0.05,
      duration: 0.5,
      // ease: "back",
      // delay: 1,
      scrollTrigger: {
        trigger: element,
        start: "top 100%",
        end: "bottom 40%",
        scrub: 0.5,
        toggleActions: "restart none none none",
        // markers: true,
      },
    });
  });

  /**SCRAMBLE TEXT */

  const tl = gsap.timeline({
    id: "text-scramble",
  });

  tl.to("#text-scramble__onebox-textbox-text", {
    scrambleText: {
      text: `SENIOR `,
      // text: "{original}",
      chars: "lowerCase",
      speed: 0.4,
    },
    delay: ScrambleDelay,
    duration: ScreambleDuration,
  });

  const tl1 = gsap.timeline({
    id: "text-scramble-1",
  });

  tl1.to("#text-scramble-1__onebox-textbox-text", {
    scrambleText: {
      text: `GRAPHIC DESIGNER`,
      chars: "lowerCase",
      speed: 0.4,
    },
    delay: ScrambleDelay,
    duration: ScreambleDuration,
  });

  const tl2 = gsap.timeline({
    id: "text-scramble-2",
  });

  tl2.to("#text-scramble-2__onebox-textbox-text", {
    scrambleText: {
      text: "PROGRESS IS NOT A GOAL",
      // text: "{original}",
      chars: "lowerCase",
      speed: 0.4,
    },
    delay: ScrambleDelay,
    duration: ScreambleDuration,
  });

  const tl3 = gsap.timeline({
    id: "text-scramble-3",
  });

  tl3.to("#text-scramble-3__onebox-textbox-text", {
    scrambleText: {
      text: "IT'S A CONSTANT",
      // text: "{original}",
      chars: "lowerCase",
      speed: 0.4,
    },
    delay: ScrambleDelay,
    duration: ScreambleDuration,
  });

  const tl4 = gsap.timeline({
    id: "text-scramble-4",
  });

  tl4.to("#text-scramble-4__onebox-textbox-text", {
    scrambleText: {
      text: "WHAT I DO",
      // text: "{original}",
      chars: "lowerCase",
      speed: 0.4,
    },
    delay: ScrambleDelay,
    duration: ScreambleDuration,
  });

  const tl5 = gsap.timeline({
    id: "text-scramble-5",
  });

  tl5.to("#text-scramble-5__onebox-textbox-text", {
    scrambleText: {
      text: "GRAPHIC DESINGING",
      // text: "{original}",
      chars: "lowerCase",
      speed: 0.4,
    },
    delay: ScrambleDelay,
    duration: ScreambleDuration,
  });

  const tl6 = gsap.timeline({
    id: "text-scramble-6",
  });

  tl6.to("#text-scramble-6__onebox-textbox-text", {
    scrambleText: {
      text: "VIDEO EDITING",
      // text: "{original}",
      chars: "lowerCase",
      speed: 0.4,
    },
    delay: ScrambleDelay,
    duration: ScreambleDuration,
  });

  const tl7 = gsap.timeline({
    id: "text-scramble-7",
  });

  tl7.to("#text-scramble-7__onebox-textbox-text", {
    scrambleText: {
      text: "MOTION DESIGNING",
      // text: "{original}",
      chars: "lowerCase",
      speed: 0.4,
    },
    delay: ScrambleDelay,
    duration: ScreambleDuration,
  });

  const tl8 = gsap.timeline({
    id: "text-scramble-8",
  });

  tl8.to("#text-scramble-8__onebox-textbox-text", {
    scrambleText: {
      text: "3D MODELING",
      // text: "{original}",
      chars: "lowerCase",
      speed: 0.4,
    },
    delay: ScrambleDelay,
    duration: ScreambleDuration,
  });

  const tl9 = gsap.timeline({
    id: "text-scramble-9",
  });

  tl9.to("#text-scramble-9__onebox-textbox-text", {
    scrambleText: {
      text: "EXPERTISE",
      // text: "{original}",
      chars: "lowerCase",
      speed: 0.4,
    },
    delay: ScrambleDelay,
    duration: ScreambleDuration,
  });

  const tl10 = gsap.timeline({
    id: "text-scramble-10",
  });

  tl10.to("#text-scramble-10__onebox-textbox-text", {
    scrambleText: {
      text: "BRANDING",
      // text: "{original}",
      chars: "lowerCase",
      speed: 0.4,
    },
    delay: ScrambleDelay,
    duration: ScreambleDuration,
  });

  const tl11 = gsap.timeline({
    id: "text-scramble-11",
  });

  tl11.to("#text-scramble-11__onebox-textbox-text", {
    scrambleText: {
      text: "PACKAGING DESIGNING",
      // text: "{original}",
      chars: "lowerCase",
      speed: 0.4,
    },
    delay: ScrambleDelay,
    duration: ScreambleDuration,
  });

  const tl12 = gsap.timeline({
    id: "text-scramble-12",
  });

  tl12.to("#text-scramble-12__onebox-textbox-text", {
    scrambleText: {
      text: "DIGITAL CREATIVES",
      // text: "{original}",
      chars: "lowerCase",
      speed: 0.4,
    },
    delay: ScrambleDelay,
    duration: ScreambleDuration,
  });

  const tl13 = gsap.timeline({
    id: "text-scramble-13",
  });

  tl13.to("#text-scramble-13__onebox-textbox-text", {
    scrambleText: {
      text: "MOTION DESIGN",
      // text: "{original}",
      chars: "lowerCase",
      speed: 0.4,
    },
    delay: ScrambleDelay,
    duration: ScreambleDuration,
  });
});

/** LINE EFFECTS */
const SectionTwo = document.querySelector(".section-two__work");
const SectionTwoLine = document.querySelector(".section-two__mainline");

const LineOptions = {
  root: null,
  threshold: 0.3,
};

function LineCallback(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      SectionTwoLine.classList.add("lineani");
      // Remove observer after first trigger
      observer.unobserve(SectionTwo);
    } else {
      SectionTwoLine.classList.remove("lineani");
    }
  });
}

const LineObserver = new IntersectionObserver(LineCallback, LineOptions);

LineObserver.observe(SectionTwo);

/** ARCHIVE */
const ArchiveSection = document.querySelector(".archive");
const ArchiveCursor = document.querySelector(".archive-cursor");
console.log(ArchiveSection);

ArchiveSection.addEventListener("mouseenter", function (e) {
  console.log(e);
  ArchiveCursor.style.position = "fixed";
  ArchiveCursor.style.display = "block";
});

ArchiveSection.addEventListener("mousemove", function (e) {
  const x = e.clientX;
  const y = e.clientY;
  ArchiveCursor.style.transform = `translate(${x}px, ${y}px)`;
  ArchiveCursor.style.transition = "transform 0.3s ease";
});

ArchiveSection.addEventListener("mouseout", function (e) {
  console.log(e);
  ArchiveCursor.style.position = "absolute";
  ArchiveCursor.style.display = "none";
});
